/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export const BASE_REAL_WORLD_OBJECTS_ENDPOINT = '/HttpTriggerEditRWOThumbnail'
export const DELETE_RWO_ENDPOINT = '/HttpTriggerRwo?type=deleteRwo'


// Delete whole RWO dialog
export const DELETE_WHOLE_RWO_WARNING_TEXT = "Are you sure you want to delete this RWO? This action cannot be undone. This will first check this is referenced anywhere, and if not it will delete it."
export const DELETE_WHOLE_RWO_TITLE_TEXT = "Delete RWO"

// Delete version of RWO dialog
export const DELETE_RWO_VERSION_WARNING_TEXT = "Are you sure you want to delete this version of the RWO? This action cannot be undone. This will first check this is referenced anywhere, and if not it will delete it."
export const DELETE_RWO_VERSION_TITLE_TEXT = "Delete RWO Version"

// Delete RWO variant dialog
export const DELETE_RWO_VARIANT_WARNING_TEXT = "Are you sure you want to delete this variant of the RWO? This will not modify this RWO version; you must save a new version to save the changes."
export const DELETE_RWO_VARIANT_TITLE_TEXT = "Delete RWO Variant"

// Column names for the Signs Report
export const COLUMN_NAMES = {
    SIGN_NAME: "Sign Name",
    SIGN_TYPE: "Sign Type",
    KNOWN_OFFICIAL_SIGN_DESIGNATIONS: "Known Official Sign Designations",
    MESSAGE_TYPE: "Message Type",
    ROAR_ID: "ROAR ID",
    ROAR_URL: "ROAR URL",
    REAL_DESC: "Real World Example Description",
    REAL_URL: "Real World Example URL",
    SIGN_SHAPE: "Sign Shape",
    KNOWN_SIGN_COLOR: "Known Sign Color",
    REFERENCE_IMAGE_FILE_NAME: "Reference Image File Name",
    LATEST_VERSION: "Latest Version",
    LAST_UPDATED: "Last Updated",
    KNOWN_ODDS: "Known ODDs",
    WIDTH: "Width",
    HEIGHT: "Height",
    LENGTH: "Length",
    ID: "ID",
    COMMENT: "Comment",
    COMMENTS: "Comments",
    OBJECT_REQUEST_SOURCE: "Object Request Source",
    REFERENCES: "References",
    OBJECT_NAME_PROFILE:"Object Name/Profile",
    PROFILE:"Profile",
    ORIENTATION_WIDTH: "Orientation Width",
    ORIENTATION_HEIGHT: "Orientation Height",
    RADAR_CROSS_SECTION: "Radar Cross Section",
    RETROREFLECTIVITY: "Retroreflectivity",
};

// Values for the keys in the data object
export const VALUE_KEYS = {
    SIGN_NAME: "signName",
    SIGN_TYPE: "signType",
    KNOWN_OFFICIAL_SIGN_DESIGNATIONS: "knownOfficialSign",
    MESSAGE_TYPE: "messageType",
    REAL_DESC: "realDesc",
    REAL_URL: "realUrl",
    ROAR_ID: "roarId",
    ROAR_URL: "roarUrl",
    SIGN_SHAPE: "signShape",
    KNOWN_SIGN_COLOR: "knownSignColor",
    REFERENCE_IMAGE_FILE_NAME: "fileName",
    LATEST_VERSION: "latestVersion",
    LAST_UPDATED: "lastUpdated",
    KNOWN_ODDS: "knownOdds",
    WIDTH: "width",
    HEIGHT: "height",
    LENGTH: "length",
    ID: "id",
    COMMENT: "comments",
    WHEELBASE: "wheelbase",
    MAXIMUM_WIDTH: "maximumWidth",
    MAXIMUM_HEIGHT: "maximumHeight",
    MAXIMUM_LENGTH: "maximumLength",
    REFERENCES: "references",
    OBJECT_REQUEST_SOURCE: "objectRequestSource",
    SIZE_ID: "sizeID",
    PARENT_ID: "parentId",
    USAGE_SPEED_ID: "usageSpeedID",
    SIGN_SIZE_VARIANT: "signSizeVariant",
    SIGN_VARIANTS: "signVariants",
};
// Mapping of the column names to the keys in the data object
export const COLUMN_SIGNS_REPORT_TITLE_TO_KEY_MAP = {
    [COLUMN_NAMES.SIGN_NAME]: VALUE_KEYS.SIGN_NAME,
    [COLUMN_NAMES.SIGN_TYPE]: VALUE_KEYS.SIGN_TYPE,
    [COLUMN_NAMES.KNOWN_OFFICIAL_SIGN_DESIGNATIONS]: VALUE_KEYS.KNOWN_OFFICIAL_SIGN_DESIGNATIONS,
    [COLUMN_NAMES.MESSAGE_TYPE]: VALUE_KEYS.MESSAGE_TYPE,
    [COLUMN_NAMES.REAL_DESC]: VALUE_KEYS.REAL_DESC,
    [COLUMN_NAMES.REAL_URL]: VALUE_KEYS.REAL_URL,
    [COLUMN_NAMES.ROAR_ID]: VALUE_KEYS.ROAR_ID,
    [COLUMN_NAMES.ROAR_URL]: VALUE_KEYS.ROAR_URL,
    [COLUMN_NAMES.SIGN_SHAPE]: VALUE_KEYS.SIGN_SHAPE,
    [COLUMN_NAMES.KNOWN_SIGN_COLOR]: VALUE_KEYS.KNOWN_SIGN_COLOR,
    [COLUMN_NAMES.REFERENCE_IMAGE_FILE_NAME]: VALUE_KEYS.REFERENCE_IMAGE_FILE_NAME,
    [COLUMN_NAMES.LATEST_VERSION]: VALUE_KEYS.LATEST_VERSION,
    [COLUMN_NAMES.LAST_UPDATED]: VALUE_KEYS.LAST_UPDATED,
    [COLUMN_NAMES.KNOWN_ODDS]: VALUE_KEYS.KNOWN_ODDS,
    [COLUMN_NAMES.WIDTH]: VALUE_KEYS.WIDTH,
    [COLUMN_NAMES.HEIGHT]: VALUE_KEYS.HEIGHT,
    [COLUMN_NAMES.LENGTH]: VALUE_KEYS.LENGTH,
    [COLUMN_NAMES.ID]: VALUE_KEYS.ID,
    [COLUMN_NAMES.COMMENT]: VALUE_KEYS.COMMENT,
};